export enum ContextSelectorStep {
  Company = 0,
  Customer = 1,
  Order = 2,
  Finished = 3,
}
